import { render, staticRenderFns } from "./PurposesView.vue?vue&type=template&id=380c31fb&scoped=true&"
import script from "./PurposesView.vue?vue&type=script&lang=js&"
export * from "./PurposesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c31fb",
  null
  
)

export default component.exports